import type { DefaultGenerics, StreamChat } from "stream-chat";

import { createContext, use } from "react";

export const StreamContext = createContext<StreamChat<DefaultGenerics> | null>(null);

// Null pour un club freemium : l'API ne lui délivre pas de token StreamChat, donc
// aucun client n'est instancié. Les consommateurs doivent no-op quand le client
// est null (les surfaces de messagerie leur sont par ailleurs masquées).
export const useStreamClient = () => use(StreamContext);
